import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Row, Col } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { Add, UserAgent, UserAgentList, Search, Filter, AdduserAgent } from '../../../Constant';
import { useForm } from 'react-hook-form';
import { Deleteagent, DeleteagentRole, viewAccountRole, viewAgent, viewAgentRole, showStaffList, showStaffListRole, DeleteStaff, DeleteStaffRole } from '../../../CommonUrl';
import { useSelector } from 'react-redux';
import { conditionalRow } from '../../Common/Rowstyle/Rowstyle';
import Transparentspinner from '../../Common/Loader/Transparentspinner';
import { toast } from 'react-toastify';
// import PasswordChange from './PasswordChange';
import Popup from '../../Common/Popup/popup';
import { AgentColumns } from '../tableHeader';
import Button from '../../Common/Elements/Button';
import AddEditStaff from './AddEditStaff';

const EmployeeList = () => {
    const { register, handleSubmit } = useForm({});
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const changepwdtitile = <span className='billerqColor bolder '><h3>Change Password</h3></span>;
    const [agentLists, setAgentList] = useState([]);
    const [filters, setFilters] = useState({
        search: '',
    });
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [userValue, setUserValue] = useState('');
    const [modal, setModal] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: '', order: '' });


    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortConfig.column === column.id) {
            newOrder = sortConfig.order === 'asc' ? 'desc' : 'asc';
        }
        setSortConfig({ column: column.id, order: newOrder });
        fetchAgent(currentPage, perPage, filters.search, column.id, newOrder);
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const handleModal = (id) => {
        navigate('/attendance/add-staff')
    };

    const ActionCell = ({ row }) => {
        const [dropdownOpen, setDropdownOpen] = React.useState(false);
        const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

        const handleEditClick = () => {
            const editFormURL = `${process.env.PUBLIC_URL}/attendance/add-staff?id=${row.id}`;
            navigate(editFormURL);
        };

        const deleteCustomerList = (id) => {
            SweetAlert.fire({
                title: 'Confirm deletion?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'cancel',
                reverseButtons: true
            }).then(async (result) => {
                setLoading(true);
                if (result.value) {
                    const deleteRes = { staff_list_id: id }
                    const customerDelete = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? DeleteStaff : DeleteStaffRole, deleteRes);
                    if (customerDelete.status === 200) {
                        if (customerDelete.data.status) {
                            SweetAlert.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            );
                            toast.success(customerDelete.data.message)
                            fetchAgent(1, perPage, sortConfig.column, sortConfig.order);
                        } else {
                            toast.error(customerDelete.data.message);
                        }

                    } else {
                        handleApiError(customerDelete.status);
                    }
                    setLoading(false);
                }
            });
        };

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ padding: '6px 12px', fontSize: '14px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                    {
                        (authState.userRole === 1 ||
                            authState.permissions.includes('edit-user')) &&
                        <DropdownItem style={toggleStyle} onClick={() => handleEditClick()}>Edit</DropdownItem>
                    }
                  
                    {
                        (authState.userRole === 1 ||
                            authState.permissions.includes('delete-user')) &&
                        <DropdownItem style={{ padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px' }} onClick={() => deleteCustomerList(row.id)}>Delete</DropdownItem>
                    }
                </DropdownMenu>
            </Dropdown>
        );
    };

    const fetchAgent = async (page, size = perPage, searchKey = '', sortBy = '', sortOrder = '') => {
        setLoading(true);
        const endpoint = authState.userRole === 1 ? showStaffList : showStaffListRole;
        const response = await getClientUrlDataToken(
            authState.apiUrl,
            `${endpoint}?page=${page}&page_length=${size}&search=${searchKey}&sort_by=${sortBy}&sort_order=${sortOrder}`
        );
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const SerialNo = (page - 1) * size + 1;
            setAgentList(response.data.data.map((e, index) => {
                // const name = e.name || `${e.first_name || ''} ${e.last_name || ''}`.trim() || `Staff #${e.id}`;
                // const email = e.email || e.department || 'N/A';
                // const role = e.role_name || e.role || e.employment || e.employment_type || 'N/A';
                // const status = e.status || e.leave_status || 'active';
                // const mobile = e.mobile || e.shift || 'N/A';
                // const enableStock = e.stock_enabled || e.today_status || e.today || 'N/A';

                return {
                    Si: SerialNo + index,
                    Name: e.employee_name || 'N/A',
                    email: e.email || 'N/A',
                    role: e.role_name || 'N/A',
                    shift: e.shift_name || 'N/A',
                    Status: e.status || 'N/A',
                    id: e.id,
                    Mobile: e?.mobile,
                    leave: e?.today|| e?.leave_status || 'N/A',
                    zone:e?.geofence_zone ||'N/A'


                };
            }))
            setTotalRows(response.data.total || 0);
        } else {
            handleApiError(response.status);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchAgent(1);
    }, []);

    const handlePageChange = page => {
        fetchAgent(page, perPage, filters.search, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchAgent(page, newPerPage, filters.search, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };

    const onSubmit = async (data) => {
        const search = data.search;
        setFilters({
            search,
        });
        fetchAgent(1, perPage, search);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={UserAgent} parent="Staff" title={UserAgentList} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-5px 0 -20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{UserAgentList}</H3>
                    {
                        //       (authState.userRole === 1 ||
                        // authState.permissions.includes('store-user')) && 
                        <div>
                            <Button onClick={handleModal} className="btn btn-primary">{Add}</Button>
                        </div>
                    }
                </CardHeader>
                <CardBody>
                    <span className='custom-span'>

                        <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                            <Row className="ps-3 mb-4 custom-search-filter align-items-center">
                                <Col xs="6" sm="4" md="2" lg="2">
                                    <input className="form-control" placeholder={Search} type="text"
                                        {...register('search')} />
                                </Col>
                                <Col xs="6" sm="6" md="4" lg="3">
                                    <Btn className="custom-filter-btn" attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                                </Col>
                            </Row>
                        </Form>
                    </span>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={AgentColumns( ActionCell)}
                            data={agentLists}
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            conditionalRowStyles={conditionalRow}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
            <Popup size="md" isOpen={modal} title={AdduserAgent} toggler={handleModal}>
                <AddEditStaff />
                {/* <PasswordChange setModal={setModal}  userValue={userValue}/> */}
            </Popup>
        </Fragment>
    );
};

export default EmployeeList;